// extracted by mini-css-extract-plugin
module.exports = {"TotalCountProduct":"CountProduct_TotalCountProduct__1udBU"};